export const INCREMENT_MEDIA_GALLERY_IDX = 'INCREMENT_MEDIA_GALLERY_IDX';
export const DECREMENT_MEDIA_GALLERY_IDX = 'DECREMENT_MEDIA_GALLERY_IDX';

export function incrementMediaGalleryIdx() {
  return { type: INCREMENT_MEDIA_GALLERY_IDX };
}

export function decrementMediaGalleryIdx() {
  return { type: DECREMENT_MEDIA_GALLERY_IDX };
}
